import React from "react";
import { TextField } from "@material-ui/core";
import { useFormikContext } from "formik";
import _ from "lodash";

const FormikTextField = (props) => {
  const { name, component: Component, ...rest } = props;

  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    isSubmitting,
    inputProps,
  } = useFormikContext();

  const Field = Component || TextField;

  return (
    <Field
      variant={rest.variant || "outlined"}
      id={rest.id || name}
      margin={rest.margin || "dense"}
      fullWidth
      name={name}
      value={_.get(values, name) || ""}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={rest.disabled || isSubmitting}
      error={Boolean(_.get(touched, name) && _.get(errors, name))}
      helperText={_.get(touched, name) && _.get(errors, name)}
      inputProps={inputProps}
      {...rest}
    />
  );
};

export default FormikTextField;
